angular.module('unica_campaign.campaign_routes', [
	'ui.router'
])

.config(function($stateProvider) {

	$stateProvider

		// CAMPAIGN
		.state('app.campaign', {
			url: '/campaign',
			abstract: true,
			views: {
				'mainContent': {
					templateUrl: './modules/campaign/templates/campaign.html',
					controller: 'CampaignBasicController'
				}
			},
			params: {
				need_auth: true
			}
		})

			// CAMPAIGN LIST
			.state('app.campaign.list', {
				url: '/list/:event_id',
				views: {
					'campaignContent': {
						templateUrl: './modules/campaign/templates/list.html',
						controller: 'CampaignListController'
					}
				},
				ncyBreadcrumb: {
					label: 'Lista Campagne',
					parent: function($scope) {
						return 'app.event.detail({year: ' + $scope.year + ',id:' + $scope.event_id + '})';
					}
				}
			})

			// CAMPAIGN CREATE
			.state('app.campaign.create', {
				url: '/create/:event_id',
				views: {
					'campaignContent': {
						templateUrl: './modules/campaign/templates/create.html',
						controller: 'CampaignCreateController'
					}
				},
				params: {
					need_auth: true
				},
				ncyBreadcrumb: {
					label: 'Crea Campagna',
					parent: 'app.campaign.list'
				}
			})

			// CAMPAIGN EDIT
			.state('app.campaign.edit', {
				url: '/edit/:event_id/:id',
				views: {
					'campaignContent': {
						templateUrl: './modules/campaign/templates/edit.html',
						controller: 'CampaignEditController'
					}
				},
				params: {
					need_auth: true
				},
				ncyBreadcrumb: {
					label: 'Modifica Campagna',
					parent: 'app.campaign.list'
				}
			})

			// CAMPAIGN ASSIGN
			.state('app.campaign.assign', {
				url: '/assign/:event_id/:id',
				views: {
					'campaignContent': {
						templateUrl: './modules/campaign/templates/assign.html',
						controller: 'CampaignAssignController'
					}
				},
				params: {
					need_auth: true
				},
				ncyBreadcrumb: {
					label: 'Seleziona Invitati',
					parent: 'app.campaign.list'
				}
			})
	;


});
